// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kb-welcome {
  text-align: center;
  padding: 48px 24px 32px;
}

.kb-welcome-icon {
  font-size: 2.5rem;
  color: #4a90d9;
  margin-bottom: 12px;
}

.kb-welcome h3 {
  font-weight: 700;
  color: #1a1a2e;
  margin-bottom: 8px;
}

.kb-welcome-sub {
  color: #6c757d;
  font-size: 0.95rem;
  margin-bottom: 36px;
}

.kb-welcome-cards {
  display: flex;
  gap: 20px;
  justify-content: center;
  margin-bottom: 36px;
}

.kb-tip-card {
  display: flex;
  flex-direction: column;
  gap: 6px;
  background: #f8f9fb;
  border: 1px solid #e8eaed;
  border-radius: 10px;
  padding: 20px 18px;
  max-width: 220px;
  text-align: left;
}

.kb-tip-card i {
  font-size: 1.3rem;
  color: #4a90d9;
  margin-bottom: 4px;
}

.kb-tip-card strong {
  font-size: 0.88rem;
  color: #1a1a2e;
}

.kb-tip-card span {
  font-size: 0.82rem;
  color: #6c757d;
  line-height: 1.5;
}

.kb-welcome-footer {
  font-size: 0.82rem;
  color: #9ca3af;
}
`, "",{"version":3,"sources":["webpack://./src/app/knowledge-base-module/components/kb-welcome/kb-welcome.component.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB","sourcesContent":[".kb-welcome {\n  text-align: center;\n  padding: 48px 24px 32px;\n}\n\n.kb-welcome-icon {\n  font-size: 2.5rem;\n  color: #4a90d9;\n  margin-bottom: 12px;\n}\n\n.kb-welcome h3 {\n  font-weight: 700;\n  color: #1a1a2e;\n  margin-bottom: 8px;\n}\n\n.kb-welcome-sub {\n  color: #6c757d;\n  font-size: 0.95rem;\n  margin-bottom: 36px;\n}\n\n.kb-welcome-cards {\n  display: flex;\n  gap: 20px;\n  justify-content: center;\n  margin-bottom: 36px;\n}\n\n.kb-tip-card {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  background: #f8f9fb;\n  border: 1px solid #e8eaed;\n  border-radius: 10px;\n  padding: 20px 18px;\n  max-width: 220px;\n  text-align: left;\n}\n\n.kb-tip-card i {\n  font-size: 1.3rem;\n  color: #4a90d9;\n  margin-bottom: 4px;\n}\n\n.kb-tip-card strong {\n  font-size: 0.88rem;\n  color: #1a1a2e;\n}\n\n.kb-tip-card span {\n  font-size: 0.82rem;\n  color: #6c757d;\n  line-height: 1.5;\n}\n\n.kb-welcome-footer {\n  font-size: 0.82rem;\n  color: #9ca3af;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
